import { addNavMenuItem, registerFormInputComponent } from '@vendure/admin-ui/core';
import { RelationProductVariantInputComponent } from './components/relation-product-variant-input/relation-product-variant-input.component';

export default [
    RelationProductVariantInputComponent,
    addNavMenuItem(
        {
            id: 'holiday-orders',
            label: 'Holiday Orders',
            routerLink: ['/extensions/sales/holiday-orders'],
            icon: 'shopping-cart',
        },
        'sales',
    ),
    registerFormInputComponent('addon-variant-selector', RelationProductVariantInputComponent),
];
